import { render, staticRenderFns } from "./ContinuousFilingFormDetails.vue?vue&type=template&id=5c1611a4&scoped=true&"
import script from "./ContinuousFilingFormDetails.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingFormDetails.vue?vue&type=style&index=0&id=5c1611a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1611a4",
  null
  
)

export default component.exports